import React, { useState } from "react";
import OnsiteVolunteerForm from "./OnsiteVolunteerForm";
import WebData from "../../../../Helpers/WebData";
import ReactMarkdown from "react-markdown";
import "./OnsiteVolunteer.style.css";

const OnsiteVolunteer = () => {
  const [current, setCurrent] = useState(0);
  function showNextCard() {
    if (current < WebData.onsiteVolunteer.items.length - 1) {
      setCurrent(current + 1);
    }
  }

  function showPrevCard() {
    if (current > 0) {
      setCurrent(current - 1);
    }
  }
  const paragraph =
    "If you like beaches, coconuts, cows, elephants, organics, meditation, Kerala or simply wanted a break then why don’t you visit us. Make new friends, have fun, create memories, while you make a difference to cows, the environment, rural economy, gene pool diversity, and more. We are excited to see you in ";
  return (
    <>
      <section id="onsiteVolunteerTab">
        <div className="custom-row">
          <div className="engage-container gm-content-wrapper content-view1">
            <div className="scrollbar-hide gm-para">
              <p className="justify-desc">
                <ReactMarkdown className="mb-0 markdown">
                  {paragraph}
                </ReactMarkdown>
                <a
                  href="https://goo.gl/maps/pKYwnEhrWhrKEzfp8"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  Punnyurkulam
                </a>
                !
              </p>
            </div>
            <div className="scrollbar-hide">
              <OnsiteVolunteerForm />
            </div>
          </div>
          <div className=" d-flex align-items-center justify-content-center gm-image image-view1">
            <div className="gm-img">
              <span
                id="right-arrow"
                className={`fa fa-chevron-right ${
                  current === WebData.onsiteVolunteer.items.length - 1
                    ? "fa-disabled"
                    : ""
                }`}
                onClick={() => showNextCard()}
              ></span>
              <span
                id="left-arrow"
                className={`fa fa-chevron-left ${
                  current === 0 ? "fa-disabled" : ""
                }`}
                onClick={() => showPrevCard()}
              ></span>
              <img
                className="d-none d-md-flex"
                src={WebData.onsiteVolunteer.items[current].desktopImg}
                alt=""
                srcset=""
              />
              <img
                className="d-flex d-md-none"
                src={WebData.onsiteVolunteer.items[current].phoneImg}
                alt=""
                srcset=""
              />
              <div className="thumbs d-flex">
                {WebData.onsiteVolunteer.items[current].thumb}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default OnsiteVolunteer;
